import { Skeleton } from "@/components/ui/feedback/skeleton";
import { A4_PREVIEW_WIDTH_PX } from "@/components/ui/report/TemplateStudioEmptyCanvas/TemplateStudioEmptyCanvas";

/** Speeds up the default 2s `animate-pulse` for a snappier loading feel. */
const FAST_PULSE = "[animation-duration:1.2s]";

/** Caption shown while Herald generates or refines a layout. */
export const TemplateStudioGeneratingCaption = () => (
  <p className="inline-flex items-center gap-1.5 text-xs text-slate-400 font-light tracking-wide">
    <span
      className="size-1.5 shrink-0 animate-pulse rounded-full bg-violet-800"
      aria-hidden
    />
    Herald is laying out the template
  </p>
);

const SkeletonSection = () => (
  <div className="flex flex-col gap-2">
    <Skeleton className={`h-2.5 w-20 rounded-full ${FAST_PULSE}`} />
    <Skeleton className={`h-16 w-full rounded-lg ${FAST_PULSE}`} />
  </div>
);

/**
 * Page-shaped skeleton shown on the Template Studio canvas while Herald
 * generates a layout for the first time.
 */
export const TemplateStudioCanvasSkeleton = () => (
  <div className="w-full">
    <div
      role="status"
      aria-live="polite"
      aria-label="Herald is laying out the template"
      className="mx-auto w-full rounded-2xl border border-gray-100 bg-white p-12 shadow-xs"
      style={{ maxWidth: A4_PREVIEW_WIDTH_PX }}
    >
      <div className="flex flex-col gap-2.5">
        <Skeleton className={`h-2 w-28 rounded-full ${FAST_PULSE}`} />
        <Skeleton className={`h-5 w-[65%] rounded-full ${FAST_PULSE}`} />
        <Skeleton className={`h-2.5 w-1/2 rounded-full ${FAST_PULSE}`} />
      </div>

      <hr className="my-6 border-gray-100" />

      <div className="flex flex-col gap-6">
        <SkeletonSection />
        <SkeletonSection />
        <SkeletonSection />
      </div>

      <div className="mt-8 flex justify-center">
        <TemplateStudioGeneratingCaption />
      </div>
    </div>
  </div>
);
